// @flow

import React from 'react';
import PropTypes from 'prop-types';
import ProjectContentDescription from '../ContentDescription';
import Tooltip from '../../../../../Resources/Common/Tooltip';

export default function Strengths(props) {
  const { proposalUid, blocked, hasRights } = props;
  return (
    <ProjectContentDescription
      title="Points forts"
      tooltip={Tooltip.ProjectOfferStrengths.description}
      proposalUid={proposalUid}
      blocked={blocked}
      hasRights={hasRights}
    />
  );
}

Strengths.propTypes = {
  hasRights: PropTypes.bool.isRequired,
  blocked: PropTypes.bool.isRequired,
  proposalUid: PropTypes.string
};

Strengths.defaultProps = {
  proposalUid: undefined
};
